<template>
<div>

    <!-- <template v-if="displayImage">
        <img xxxv-on="on" @click="showDialog" class="round subtle-shadow clickable glow-hover" width="50" v-bind:src="item.image"/>
    </template> -->
    <template> 
        <!-- v-else> -->
        <v-btn text @click="showDialog">Image</v-btn>
    </template>

    <v-dialog max-width="235" min-width="100" v-model="dialogVisible" transition="v-fade-transition" :hide-overlay=false scrollable>
        <div class="dialog-container">

            <div class="dialog-body" style="padding:25px 35px 0px 35px">
                <div style="text-align:center;margin-bottom:5px">
                    {{title}}
                </div>    

                <croppa v-model="imageObject"
                    :width="150"
                    :height="150"
                    :quality="1"
                    placeholder="Choose..."
                    :placeholder-font-size="16"
                    :disabled="false"
                    :prevent-white-space="true"
                    :show-remove-button="true"
                    :remove-button-size="20"
                    @zoom="imageChanged"
                    @move="imageChanged"
                    @file-choose="imageChanged"
                    @image-remove="imageChanged">
                    <img crossOrigin="Anonymous" :src="displayImage" slot="initial" />
                </croppa>
            </div>

            <div class="dialog-footer">
                <v-progress-circular style="margin-right:30px" v-if="uploading" indeterminate color="primary"></v-progress-circular>
                <v-btn @click="upload" :disabled="!dirty" v-if="!uploading" text>Keep</v-btn>
                <v-btn text @click="dialogVisible = false">Cancel</v-btn>
            </div>
        </div>
    </v-dialog>

</div>
</template>

<script>

import Utilities from '../helpers/Utilities'
import DataHelpers from '../helpers/DataHelpers'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import NiceData from '../data/NiceData';

export default {
    data() {
        return {
            dialogVisible: false,
            imageObject: {},
            dirty: false,
            uploading: false,
        }
    },
    
    props: {
        item: Object
    },

    computed: {
        displayImage() {
            //this.item.image && 
            if(this.item.image && this.item.image.indexOf('randomuser') < 0 && this.item.image.indexOf('transparent') < 0) {
                return this.item.image;
            }
            return ''
        },

        title() {
            if(this.dirty)
                return "Click 'Keep' when ready"
            if(this.chosenFile || this.item.image)
                return "Select, zoom, move"
            return "Select an image"
        }
    },

    methods: {

        imageChanged() {
            this.dirty = true
        },

        initialise() {
            this.dirty = false
            this.uploading = false
        },

        showDialog() {
            this.initialise()
            this.dialogVisible = true
        },

        upload() {
            const contactKey = NiceData.safelyGetKey(this.item)
            if(!this.imageObject.hasImage()) {
                this.saveToContact('')
                return
            }
            this.uploading = true
            this.imageObject.generateBlob((blob) => {
                    let tenantKey = this.$store.getters.tenantKey
                    
                    firebase.storage().ref('tenants/' + tenantKey + '/avatars/' + contactKey).put(blob)
                    .then(fileData => {
                        fileData.ref.getDownloadURL().then(url => {
                            console.log('Finished uploading', url)
                            this.saveToContact(url)
                        })
                        
                    })

            },'image/jpeg', 0.5)
        },

        saveToContact(url) {
            this.item.image = url
            this.uploading = false
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.croppa-container {
    margin:5px;
    background-color: #eee;
    border: 4px solid white;
    border-radius: 3px;
    box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.15);
 }
 
 .croppa-container:hover {
   opacity: 1;
   background-color: #ddd;
 }   
</style>




// WEBPACK FOOTER //
// ImageEditor.vue?556a8fa4